import { AvvirEvent } from "type_aliases";
import { FloorTradeDeviationMagnitudes } from "../../../services/reducers/domain/reduce_floor_trade_deviation_magnitudes";

export type FloorTradeDeviationMagnitudesLoadedEvent = AvvirEvent<typeof FLOOR_TRADE_DEVIATION_MAGNITUDES_LOADED, {
  projectId: string,
  magnitudes: FloorTradeDeviationMagnitudes,
  currentScan: boolean
}>

const floorTradeDeviationMagnitudesLoaded = (projectId: string, magnitudes: FloorTradeDeviationMagnitudes, currentScan: boolean): FloorTradeDeviationMagnitudesLoadedEvent => ({
  type: FLOOR_TRADE_DEVIATION_MAGNITUDES_LOADED,
  payload: {
    projectId,
    magnitudes,
    currentScan
  }
});

export const FLOOR_TRADE_DEVIATION_MAGNITUDES_LOADED = "floor_trade_deviation_magnitudes_loaded";

export default floorTradeDeviationMagnitudesLoaded;
